<template>
  <div>
    <Junanaho></Junanaho>
  </div>
</template>

<script>
import Junanaho from "./components/Junanaho.vue";

export default {
  name: "App",
  components: {
    Junanaho,
  },
};
</script>
